var AccuracyLevel;
(function (AccuracyLevel) {
    AccuracyLevel[AccuracyLevel["low"] = 0] = "low";
    AccuracyLevel[AccuracyLevel["mediocre"] = 1] = "mediocre";
    AccuracyLevel[AccuracyLevel["medium"] = 2] = "medium";
    AccuracyLevel[AccuracyLevel["good"] = 3] = "good";
    AccuracyLevel[AccuracyLevel["high"] = 4] = "high";
})(AccuracyLevel || (AccuracyLevel = {}));
export default AccuracyLevel;
